
import LayoutContent from '../../components/layouts/content2';
import React, { useEffect, useState } from 'react';

import { getImage, getData } from '../../helpers/indexedDbHelper';
import {useTranslation} from 'react-i18next';
import { useRefresh } from '../../hooks/useRefresh';
import translate from '../../helpers/translate';
import translateMenu from '../../helpers/translateMenu';
import ListProducts from './ListProducts';
import SpecialsScreen from './specials';
import DetailProduct from './DetailProduct';
import CategoriesScreen from './categories';

function Index({dishMenu, setShowDetailProduct, setShowListProduct2, goHome}) { 

      const {i18n} = useTranslation();
      const langEng = i18n.language === 'en' ?? false;
  
      const { dish, alldish } = dishMenu;
    
        const [showCategories, setshowCategories] = useState(false);
    

    const [dataDish, setDataDish] = useState(dish);
  const [dataDish2, setDataDish2] = useState(false);
      const [dataDesserts, setDataDesserts] = useState(false);
      const [dataDrinks, setDataDrinks] = useState(false);
    
    const [isImageLoading, setIsImageLoading] = useState(true); 
    const [isImageLoadingOne, setIsImageLoadingOne] = useState(true); 
    const [isImageLoadingTwo, setIsImageLoadingTwo] = useState(true); 

    const [image, setImage] = useState(false);
     const [imageOne, setImageOne] = useState(false);
        const [imageTwo, setImageTwo] = useState(false);
    
        const [showListProduct, setShowListProduct] = useState(false);
        const [dishs, setdishs] = useState(false);
  
      const {change} = useRefresh();
        const [menus, setMenus] = useState([]);
    
    const [flavors, setFlavors] = useState(dish.flavors);
    
    const [showSpecials, setShowSpecials] = useState(false);


      const [showDetailProduc2, setShowDetailProduct2] = useState(false);

    useEffect(() => {
        setFlavors(dataDish.flavors);
    }, [dataDish]);
    
      useEffect(() => {
          getData('menu').then((items) => {
              const data = items.value.data;
              setMenus(data);
          });
      }, [change]);
      
        const [dataCarne, setdataCarne] = useState(false);
      const [carnte, setcarnte] = useState(false);
    
          useEffect(() => {
                menus.map((item) => {
                    
                     if (item.id === 469) {
                        setcarnte(item);
                    }
                });
          }, [menus]);
        
        
         useEffect(() => {
             if (carnte) {
                 carnte.menus.map((item) => {
                     if (item.id === 4375) {
                      setdataCarne(item)
                    
                   }
               })
           }
         }, [carnte]);
    
    
      
    useEffect(() => {
        setIsImageLoading(true);
        setIsImageLoadingOne(true);
        setIsImageLoadingTwo(true);
          fetchImage(`menu-image-h-${dataDish.id}`).then((url) => {
              if (url) {
                  setImage(url);
                  setIsImageLoading(false); 
              }
          });

           fetchImage(`menu-image-one-${dataDish.id}`).then(async (url) => {
               if (url) {
                   const isValid = await isValidImage(url);
                   if (isValid) {
                       setImageOne(url);
                        setIsImageLoadingOne(false);
                    }
                }    
            }); 

        fetchImage(`menu-image-two-${dataDish.id}`).then(async (url) => {
            if (url) {
                const isValid = await isValidImage(url);
                if (isValid) {
                    setImageTwo(url);
                     setIsImageLoadingTwo(false);
                }
                
            }
        });
  
      }, [dataDish]);
      
    
    const isValidImage =(url) => {
            return new Promise((resolve) => {
                const img = new Image();
                img.onload = () => resolve(true); // La imagen se cargó correctamente
                img.onerror = () => resolve(false); // La imagen está rota o no se puede cargar
                img.src = url; // Inicia la carga de la imagen
            });
        }
  
       useEffect(() => {
          menus.map((item) => {
              if (item.id === 869) {
              setDataDesserts(item);
              }
              
              if (item.id === 866) {
                  setDataDrinks(item)
              }
         
          });
      }, [menus]);
  
  
      const fetchImage = async (id) => {
          const imageBlob = await getImage(id);
          if (imageBlob) {
              const imageURL = URL.createObjectURL(imageBlob.data.blob);
              return imageURL;
          }
          return null;
      };
  
  
      const navDish = (position) => {
          const menuIndex = alldish.findIndex(item => item === dataDish);
  
          let newIndex;
          if (position === 1) {
          newIndex = (menuIndex + 1) % alldish.length;
          } else if (position === -1) {
          newIndex = (menuIndex - 1 + alldish.length) % alldish.length;
          } else {
          return;
          }
          const newDish = alldish[newIndex];
          setDataDish(newDish);
      };
    
    return (
        <div style={{position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', zIndex: 9999}}>
            <LayoutContent goCategories={() => {
               setShowListProduct(true)
               setdishs(dataDrinks)
            }}  showLogo={true} setShowListProduct={setShowDetailProduct} setShowSpecials={() => {
            setShowSpecials(true)
            }} goHome={goHome}>
                

                <img
                        style={{
                            width: 490,
                            height: 100,
                            justifyContent: 'center',
                            objectFit: 'contain',
                            zIndex: 100,
                            alignSelf: 'center',
                            position: 'relative',
                            marginTop: -80,
                            
                        }}
                        src={require('./assets/logo.png')}
                />
                
                
                <div
                    style={ {
                        position: 'absolute',
                        zIndex: 999,
                        top: '30%',
                        left: 10,
                        }}>
                    <div
                        style={
                        {
                            width: 45,
                            height: 45,
                         
                            borderRadius: 100,
                            borderWidth: 3,
                            borderColor: 'white',
                        }
                        }
                        onClick={() => [
                        navDish(-1),
                      
                        ]}>
                        <img
                            style={{width: 40, height: 40, objectFit: 'contain', marginTop: 7}}
                            src={require('./assets/left23.png')}
                        />
                    </div>
                </div>

                 <div
                    style={ {
                        position: 'absolute',
                        zIndex: 999,
                        top: '30%',
                        right: 10,
                        }}>
                    <div
                        style={
                        {
                            width: 45,
                            height: 45,
                          
                            borderRadius: 100,
                            borderWidth: 3,
                            borderColor: 'white',
                        }
                        }
                        onClick={() => [
                        navDish(1),
                      
                        ]}>
                        <img
                            style={{width: 40, height: 40, objectFit: 'contain',  marginTop: 7}}
                            src={require('./assets/right2.png')}
                        />
                    </div>
                </div>
                


                <div style={{overflow:'scroll',  opacity: isImageLoading ? 0 : 1, 
                                    transition: "opacity 0.5s ease-in-out",paddingInline: 10, paddingBottom: 10, borderRadius: 30}}>
                    <div style={{ padding: '0px  0px 1px',  background: '#001b27',  borderRadius: 14, }}>
                        <div
                            style={{
                                position: 'relative',
                                width: '100%',
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                                overflow: 'hidden',
                              
                            }}
                        >
                            <img
                                src={image}
                                alt="Dynamic content"
                                style={{
                                    width: "100%",
                                    height: "85%",
                                    objectFit: "cover",
                                    borderRadius: 14,
                                    opacity: isImageLoading ? 0 : 1,
                                    transition: "opacity 0.5s ease-in-out",
                                }}
                                onLoad={() => setIsImageLoading(false)}
                            />
                           
                       </div>

                        <div style={{
                            
                            padding: 15,
                            borderRadius: 20,
                            
                        }}>
                                <div style={{
                                    flexDirection: 'row',
                                    justifyContent: 'space-between',
                                    alignItems: 'center',
                                    display: 'flex',
                                    
                                    
                                }}>

                                    <div style={{
                                        fontFamily: "LondrinaSolidRegular",
                                        display: 'flex',
                                        flexDirection: 'row',
                                        alignItems: 'center',
                                        justifyContent: 'space-between',
                                        width: '80%'
                                    }}>
                                        <p className='shor-text-one' style={{fontSize: 32, color: '#fae6cb', textAlign: 'left',  fontFamily: 'bignoodletitling',}}>
                                        {langEng ? dataDish.name : translate(i18n.language, dataDish.language, dataDish.name)}
                                        </p>
                                    </div>

                                <div>
                                    <div style={{
                                        display: 'flex',
                                        flexDirection: 'row',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        margin: '0px 10px',
                                        gap: 10,
                                        width: 130,
                                        textAlign: 'center',
                                        borderRadius: 10,
                                        
                                        
                                      
                                        boxSizing: 'border-box',
                                        background: '#f9e6c8',
                                       
                                        boxShadow: dataDish.price > 0
                                            ? '0px 8px 16px rgba(2, 42, 111, 0.45), inset 0px 2px 0px rgba(255, 255, 255, 0.35)'
                                            : 'none'
                                    }}>
                                        <p
                                            style={{
                                                fontSize: 35,
                                                lineHeight: 1,
                                                color: dataDish.price > 0 ? '#001b27' : '#001b27',
                                                fontWeight: 'bold',
                                                textAlign: 'center',
                                                fontFamily: "bignoodletitling",
                                                margin: 0,
                                                letterSpacing: 1
                                            }}>
                                            {flavors.length === 0 && (
                                                <>
                                                    {dataDish.price > 0
                                                        ? `$ ${dataDish.label_price ?? ''} ${
                                                            dataDish.price.toFixed(2)
                                                        }`
                                                        : 'Market Price'}
                                                </>
                                            )}
                                    </p>
                                    

                                   
                                    </div>
                                </div>
                                    </div>
                                
                                <div>
                                    <p
                                        className='shor-text-one'
                                
                                    style={{fontSize: 22, textAlign:'left', color: '#fae6cb', fontFamily: "bignoodletitling",}}>
                                    {langEng ? 
                                                    `${dataDish.regular_decription.replace(/\\n/g,'\n')}`
                                                : 
                                                `${translateMenu(
                                                    i18n.language, 
                                                    dataDish.language, 
                                                    dataDish.regular_decription, 
                                                    'regular_decription'
                                                )}`
                                        }
                                        
                                        
                                    </p>
                            </div>
                            

                        {flavors.length > 0 && (
                        <div
                                    style={{
                                display: 'flex',
                            flexDirection: 'row',
                            justifyContent: 'flex-start',
                            flexWrap: 'wrap',
                            marginTop: 10,
                            }}>
                            {flavors.map((item, key) => {
                            return (
                                <div
                                key={key}
                                style={{
                                    backgroundColor: 'black',
                                    width: '29%',
                                    marginHorizontal: 1,
                                    margin: '1px 1px',
                                    borderRadius: 10,
                                    padding: 10,
                                    
                                    display: 'flex',
                                    flexDirection: 'row',
                                    justifyContent: 'space-between',
                                    alignItems: 'center',
                                    position: 'relative',
                                    
                                }}>
                                    <p
                                        className='shor-text'
                                        style={{
                                            fontFamily: 'bignoodletitling',
                                            color: 'white',
                                            fontSize: 14,
                                            width: '85%',
                                        }}>
                                            {item.name}
                                    </p>

                                {item.price > 0 ? (
                                    <p
                                    className='shor-text'
                                    style={{
                                        color: 'white',
                                        position: 'absolute',
                                        right: 10,
                                        bottom: 6,
                                    }}>
                                    $ {item.price}
                                    </p>
                                ) : (
                                    <p
                                    style={{
                                        color: 'white',
                                        fontSize: 9,
                                        position: 'absolute',
                                        right: 10,
                                        bottom: 10,
                                    }}>
                                    Market Price
                                    </p>
                                )}
                                </div>
                            );
                            })}
                        </div>
                        )}
                                
                        </div>
                        
                    </div>


                    <center>
                        <img src={require('./assets/separa.png')} style={{ width: '70%', height: 10, objectFit: 'contain', marginTop: 40, marginBottom: 5 }} />
                    </center>

                    
                    <div
                                    style={{
                                        display: 'flex',
                                        flexDirection: 'row',
                                        justifyContent: 'space-between',
                                        alignItems: 'center',
                                    paddingInline: 20,
                                 
                                    }}>
                                    <div onClick={() => [setShowListProduct(true), setdishs(dataDesserts)]} style={{
                                                        borderRadius: 10,
                        
                                                      
                                                        display: 'flex',
                                                        justifyContent: "center",
                                                        elevation: 1,position: 'relative', flexDirection: 'column'}} >
                                        <img
                                            src={require('./assets/desserts.png')}
                                            resizeMode={'cover'}
                                            style={{
                                                width: 300,
                                                height: 220,
                                                borderRadius: 14,
                                            
                                                objectFit: 'contain',
                                                boderRadius: 20,
                                            }}
                            />
                         
                                    </div>

                                    <div onClick={() => [setShowListProduct(true), setdishs(dataDrinks)]} style={{
                                                        borderRadius: 10,
                           
                                                        display: 'flex',
                                                        justifyContent: "center",
                                                        elevation: 1,position: 'relative', flexDirection: 'column'}}>
                                        <img
                                            src={require('./assets/imagedrin.png')}
                                            resizeMode={'cover'}
                                        style={{
                                       width: 300,
                                                height: 220,
                                                borderRadius: 14,
                                            
                                                objectFit: 'contain',
                                                boderRadius: 20,
                                        }}
                            />
                           
                                   
                                    </div>
                    </div>
                    
                    

              
                </div>
            </LayoutContent>
             {showListProduct && <ListProducts
                dishs={dishs}
                setShowListProduct={setShowListProduct}
                goHome={setShowListProduct2}
            />}

            
             {showCategories && <CategoriesScreen setshowCategories={setshowCategories} />}


             {showDetailProduc2 && <DetailProduct
                                dishMenu={dataDish2}
                                setShowListProduct2={setShowListProduct}
                                setShowDetailProduct={setShowDetailProduct2}
            />}
            


             {showSpecials && <SpecialsScreen setShowListProduct={setShowSpecials} setShowHappy={setShowListProduct2}/>}
        </div>
    );
}
export default Index;